import React from 'react';
import RichTextRenderer from './RichTextRenderer';
import { DrcIconButton } from 'driscolls-react-components';
import CancelIcon from '@material-ui/icons/Cancel';

import './DriscollsBanner.css';

const DriscollsBanner = (props) => {
  const {
    content,
    onClose,
    isDismissible,
    bgColor = props.color || 'information',
    className = '',
  } = props;

  return (
    <div
      className={`hContainer noPadding bannerStyle ${bgColor} ${className}`}>
      <div  className={`hContainer noPadding bannerBody`}>
        <div className={`vContainer`}>
          <RichTextRenderer content={content} />
        </div>
      </div>
      {isDismissible && (
        <DrcIconButton          
          size="small"
          className="bannerCloseBtn"
          noStyle
          onClick={onClose}
        >
          <CancelIcon />
        </DrcIconButton>
      )}
    </div>
  );
};

export default DriscollsBanner;
